import {
  MAX_SLIDER_VALUE,
  MIN_SLIDER_VALUE,
} from '@web-platform/shared-universal-constants/src/departureTimesFilter';
import { DEPARTURE_TIMES } from '@web-platform/shared-universal-constants/src/queryParams';
import { integerRangesParamParser } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';

import type {
  DepartureTimeEntry,
  DepartureTimesState,
} from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/departureTimes';

const isValidRange = ({ end, start }: { end: number; start: number }) =>
  start >= MIN_SLIDER_VALUE &&
  end <= MAX_SLIDER_VALUE &&
  end >= start &&
  !(start === MIN_SLIDER_VALUE && end === MAX_SLIDER_VALUE);

export const getDepartureTimesFromUrl = (): DepartureTimesState =>
  integerRangesParamParser
    .deserialize(parseParams()[DEPARTURE_TIMES])
    .map((item, index) => (item && isValidRange(item) ? { ...item, legIndex: index } : null))
    .filter((item): item is DepartureTimeEntry => Boolean(item));
